import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import { FixaSkeleton } from "@coworker/apprestructured/src/shared/wrappers/FixaSkeleton/FixaSkeleton";
import ModalColumn from "@coworker/apprestructured/src/task-management/components/ModalColumn/ModalColumn";
import styles from "./TitledText.module.css";

type TitledTextProps = {
  title: string;
  text: string | undefined;
};

function TitledTextWithMargins({ title, text }: TitledTextProps) {
  return (
    <div className={styles["with-margins"]}>
      <TitledText title={title} text={text} />
    </div>
  );
}

function TitledText({ title, text }: TitledTextProps) {
  return (
    <ModalColumn gap="small">
      <FixaText textStyle="Heading.S" tagName="h2">
        {title}
      </FixaText>
      {text === undefined ? (
        <FixaSkeleton height="24px" />
      ) : (
        <FixaText className={styles["wrap-content"]} textStyle="Body.L">
          {text}
        </FixaText>
      )}
    </ModalColumn>
  );
}

export default TitledText;
export { TitledTextWithMargins };
